import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';

import CentredSpinner from '../../Components/CentredSpinner';
import DataTable from '../../DataTable/datatable.component';
import SelectFilter from '../../DataTable/datatable.selectfilter';
import RecipePropertyEditDialog from '../../Dialogs/Configuration/RecipePropertyEditDialog';
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import CommonConfigPage from './CommonConfigPage';

function RecipePropertiesTable({ showEditDialog, includeDeleted, refresh }) {

    const { fetchDataAuthenticated } = useHttpUtils();
    const [loaded, setLoaded] = useState(false);
    const [errored, setErrored] = useState(false);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const getRecipeProperties = async function () {
            let url = `api/v1/recipeproperty/?includeDeleted=${includeDeleted}`;

            await fetchDataAuthenticated(url)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                    setErrored(false);
                    setLoaded(true);
                })
                .catch(error => {
                    setErrored(true);
                    setLoaded(false);
                });
        };

        getRecipeProperties();
    }, [includeDeleted, refresh, fetchDataAuthenticated]);

    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            filter: 'includesString',
            Cell: (props) => {
                return (<Nav><Nav.Link onClick={() => { showEditDialog(props.row.original); }}>{props.value}</Nav.Link></Nav>);
            }
        },
        {
            Header: 'Description',
            accessor: 'description',
            filter: 'includesString'
        },
        {
            Header: 'Data Type',
            accessor: 'dataType',
            filter: 'includesString'
        },
        {
            Header: 'Business Unit',
            accessor: 'businessUnitName',
            Filter: SelectFilter,
            filter: 'equals'
        }
    ];

    const getRowProps = (row) => {
        if (row.original.isDeleted)
            return { className: "deleted" };

        return {};
    };


    return (loaded
        ? <DataTable tableColumns={tableColumns} tableData={tableData} getRowProps={getRowProps} autoResetPage={false} />
        : errored
            ? <p>There was a problem.</p>
            : <CentredSpinner />
    );
}

function RecipePropertyConfiguration() {

    const { businessUnits } = useBusinessUnits(false);

    const getNewRecipeProperty = () => {
        return { recipePropertyId: null, name: "", businessUnitId: null, isDeleted: false };
    };

    return (
        <CommonConfigPage
            title="Recipe Properties"
            Table={RecipePropertiesTable}
            Dialog={RecipePropertyEditDialog}
            getNewConfigObject={getNewRecipeProperty}
            businessUnits={businessUnits}
        />
    );
}

export default RecipePropertyConfiguration;